import { xyJoinX } from "../xy/index.js";
import { xysFilter } from "../xys/index.js";
import { getSlots } from "./utils/getSlots.js";
/**
 * Aligns data, can be used for spectra
 * @param data - data
 * @param options - options.
 */
export function xyArrayAlign(data, options = {}) {
    const { delta = 1, requiredY = false } = options;
    data = data.map((spectrum) => xyJoinX(spectrum, { delta }));
    const slots = getSlots(data, { delta });
    const x = Float64Array.from(slots.map((slot) => slot.average));
    const ys = Array.from(data, () => new Float64Array(x.length));
    const positions = new Uint32Array(data.length);
    for (let i = 0; i < slots.length; i++) {
        const slot = slots[i];
        for (let j = 0; j < data.length; j++) {
            const spectrum = data[j];
            while (positions[j] < spectrum.x.length &&
                spectrum.x[positions[j]] <= slot.to) {
                ys[j][i] += spectrum.y[positions[j]];
                positions[j]++;
            }
        }
    }
    if (requiredY) {
        return xysFilter({ x, ys }, { requiredY: true });
    }
    return { x, ys };
}
//# sourceMappingURL=xyArrayAlign.js.map